import { useState, useEffect } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TextField } from "@mui/material";

import {
  outlinedStyles,
  inputPropStyles,
} from "components/formFields/lineItemFieldStyle";

import { checkForUnexpectedProps } from "services/utility/misc";
import { isZero } from "services/utility/misc";

export function LineItemTextField(props) {
  const {
    name,
    disabled,
    multiline,
    maxLength,
    onValueChange,
    onClick,
    value: initialValue,
    metadata,
    number,
    money,
    width,
    endAdornment,
    cursorPointer,
    error,
    resize,
    maxRows,
    readOnly,
    dataTesting,
    lineReadOnly = false,
    ...unexpected
  } = props;
  checkForUnexpectedProps("LineItemTextField", unexpected);

  const [focused, setFocused] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [value, setValue] = useState(
    metadata?.editStr ? metadata.editStr(initialValue, metadata) : initialValue
  );

  const overflowHandling = multiline
    ? {}
    : {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      };

  const sx = {
    width,
    fontWeight: "fontWeightRegular",
    marginTop: 0,
    marginBottom: 0,
    cursor: cursorPointer ? "pointer" : "inherit",
  };

  useEffect(() => {
    setValue(
      metadata?.editStr
        ? metadata.editStr(initialValue, metadata)
        : initialValue
    );
  }, [initialValue, name, metadata]);

  function onChange(e) {
    setUpdated(true);
    if (maxLength && e.target.value.length > maxLength) {
      return;
    }

    setValue(e.target.value);
  }

  function onBlur() {
    setFocused(false);
    if (!readOnly && updated) {
      if (metadata?.editStr) {
        onValueChange(name, metadata.editStr(value, metadata));
      } else {
        onValueChange(name, value);
      }
    }
  }

  function getValue() {
    //added to update the input on focus to not show the default zero value
    if (focused && isZero(value) && !updated) {
      return "";
    }
    return value;
  }

  if (lineReadOnly) {
    const displayValue = metadata?.editStr
      ? metadata.editStr(initialValue, metadata)
      : initialValue;

    return (
      <div
        style={{
          ...overflowHandling,
          textAlign: number || money ? "right" : "left",
          fontSize: "0.8125rem",
          padding: "8px 14px",
          width: width || "100%",
        }}
      >
        {displayValue || ""}
      </div>
    );
  }

  return (
    <TextField
      readOnly={readOnly}
      autoComplete="off"
      value={getValue()}
      variant="outlined"
      onFocus={() => setFocused(true)}
      name={name}
      disabled={disabled}
      multiline={multiline}
      maxRows={maxRows}
      onChange={onChange}
      onClick={onClick}
      onBlur={onBlur}
      fullWidth={width ? false : true}
      error={error}
      data-testing={dataTesting}
      inputProps={{
        readOnly,
        style: {
          ...overflowHandling,
          textAlign: number || money ? "right" : "left",
          cursor: cursorPointer ? "pointer" : "inherit",
          resize: resize ? "both" : "none",
          minWidth: resize ? "90%" : "inherit",
          backgroundColor: "background.lineItems",
        },
      }}
      sx={error ? sx : { ...sx, ...outlinedStyles }}
      InputProps={{
        endAdornment,
        sx: inputPropStyles,
        style: {
          borderRadius: "6px",
          cursor: cursorPointer ? "pointer" : "inherit",
          backgroundColor: "background.lineItems",
        },
      }}
      InputLabelProps={{ shrink: true }}
      SelectProps={{ IconComponent: KeyboardArrowDownIcon }}
      type={money || number ? "number" : "text"}
    />
  );
}
